import React from 'react';
import { hydrate, render } from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

require('dotenv').config();
 
const root = document.getElementById('root');
if (root && root.hasChildNodes()) {
  hydrate(<App />, root);
} else {
  render(<App />, root);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister(); 
